import Location from './Location.container';

export default Location;
